import { useState, type ChangeEvent } from "react";
import { useLookupDonPayementsQuery } from "../../stores/OkOkStore";
import type { DonPayements,DonsPayementsParameters } from "../../types/Dons";
import Pager from "../Common/Pager";
import { useTrads } from "../../contexts/trads/useTrads";
import { formatDate, uniqid } from "../../tools/utils";


function DonsPayementsList({don_id} :{don_id: number}){
    const [params,setParams]=useState<DonsPayementsParameters>({page:0,r:{don_id:don_id}});
    const { data, error, isLoading } = useLookupDonPayementsQuery(params);
    const setPage=function(page:number){
        setParams({...params,page: page})
    }
    const setOrder=function(order:string,reverse?:number){
        setParams({...params,order:order,reverse:reverse ?? 0});
    }
    const changeStatus=function(e:ChangeEvent<HTMLInputElement>){
        const z:string[]=params.r?.statut ? [...params.r.statut]:[];
        if(e.target.checked){
            if(!z.includes(e.target.value)){
                z.push(e.target.value);

            }
        }else{
            const index=z.indexOf(e.target.value);
            if(index>=0){
                z.splice(index, 1);

            }
        }
        setParams(
            {...params,
                   r:{...params.r,statut:z}
            }
        );
    }
    const statusList = ['00_draft','05_paye','02_refused'];

    const statusClass=function(e:string):string{
        if(e=='00_draft'){
            return "table-primary";
        }
        if(e=='05_paye'){
            return "table-success"
        }

        if(e=='02_refused'){
            return "table-danger"
        }

        return "table-dark"
    }



    const {translate}=useTrads();
    

        return (
 
            error ? (
                <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
                <>
                <div className="d-flex flex-wrap mr-3">
                    {statusList.map((item)=>{
                        const id=uniqid();
                        return (
                            <div  className="form-check form-switch"  key={id}>
                                <input id={id} className="form-check-input"  type="checkbox" value={item} onChange={changeStatus} checked={params.r?.statut?.includes(item)} /> 
                                <label htmlFor={id} className="form-check-label">  {translate(item)}  </label>
                        
                            </div>
                        )}
                    )}
                </div>


                <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
                <table className="table table-hover">
                    <thead className="sticky-top">
                        <tr>
                            <th data-sort="id">
                                <div className="table-sort">
                                    {translate('id')}
                                    <div className={(params.order=='id')?((params.reverse)?'desc':'asc'):undefined}>
                                        <a className='up' onClick={()=>{setOrder('id',1)}} ><i className="bi"></i></a>
                                        <a className='down' onClick={()=>{setOrder('id',0)}} ><i className="bi"></i></a>
                                    </div>
                                </div>
                            </th>
                             <th data-sort="data">
                                
                                    {translate('don_payements_data')}
                                    
                                
                            </th>
                            <th data-sort="statut">

                                <div className="table-sort">
                                    {translate('statut')}
                                    <div className={(params.order=='statut')?((params.reverse)?'desc':'asc'):undefined}>
                                        <a className='up' onClick={()=>{setOrder('statut',1)}} ><i className="bi"></i></a>
                                        <a className='down' onClick={()=>{setOrder('statut',0)}} ><i className="bi"></i></a>
                                    </div>
                                </div>


                            </th>
                            <th>{translate('don_payements_remoteid')}</th>
                            <th>{translate('don_payements_methode')}</th>
                            
                            <th  data-sort="creation">


                                <div className="table-sort">
                                    {translate('creation')}
                                    <div className={(params.order=='date_creation')?((params.reverse)?'desc':'asc'):undefined}>
                                        <a className='up' onClick={()=>{setOrder('date_creation',1)}} ><i className="bi"></i></a>
                                        <a className='down' onClick={()=>{setOrder('date_creation',0)}} ><i className="bi"></i></a>
                                    </div>
                                </div>



                            </th>

                        </tr>
                    </thead>
                    <tbody>
                        {data.data.map((payement:DonPayements) => (
                            <tr key={payement.id}>
                                <td>{payement.id}</td>
                                <td>{payement.data}</td>
                                <td className={statusClass(payement.statut)}>{translate(payement.statut)}</td>
                                <td>{payement.remoteid}</td>
                                <td>{payement.methode}</td>
                                <td>{formatDate(payement.date_creation)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
                
                </>
            ):null
        );
}
export default DonsPayementsList;